import React from "react";
import { IoCheckmarkSharp } from "react-icons/io5";
import "./report.css";

// render Reported Component if user report content
const Reported = () => {
  return (
    <div className="reportBox">
      <span className="report-title">
        <IoCheckmarkSharp />
      </span>
      <span className="report-subtitle">Content reported</span>
    </div>
  );
};

// export component Reported
export default Reported;
